var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'querystring';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import withErrorBoundary from '../higherOrderComponents/withErrorBoundary';
import useFetch from '../hooks/useFetch';
import { useTracking } from '../hooks/useTracking';
import { SkeletonProvider, withSkeleton } from '../Skeleton';
import BreadcrumbList from './List';
import Skeleton from './List/skeleton';
/**
 * Use Breadcrumb as Independent Component
 * the data are being fetched by this comp
 */
export var Breadcrumb = function (_a) {
    var category = _a.category, companyId = _a.companyId, userLocale = _a.locale, props = __rest(_a, ["category", "companyId", "locale"]);
    if (!category || !companyId) {
        return React.createElement(Skeleton, null);
    }
    var locale = useIntl().locale;
    var dispatchGTMEvent = useTracking();
    var search = stringify({
        category: category,
        clientId: companyId,
        locale: (userLocale || locale).replace('-', '_'),
    });
    var _b = useFetch({
        url: "/breadcrumb?" + search,
        fetchConfig: {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    }), isLoading = _b.isLoading, response = _b.response;
    useEffect(function () {
        if (response && response.breadCrumb) {
            dispatchGTMEvent({
                event: 'categoryData',
                eventCategory: 'data',
                categoryId: category.toString(),
                categoryPath: response.breadCrumb.map(function (item) { return item.name; }),
                categoryIds: response.breadCrumb.map(function (item) { return item.id; }),
            });
        }
    }, [response]); // Use object here to identify change to valid response. Shouldn't be a problem on rerender.
    return (React.createElement(SkeletonProvider, { isLoading: !response || isLoading },
        React.createElement(BreadcrumbList, __assign({ data: response }, props))));
};
export default withSkeleton(withErrorBoundary(Breadcrumb, function () { return null; }, function () { return null; }), Skeleton);
//# sourceMappingURL=index.js.map